import { TimeAgo } from '@/components/time-ago';
import { DistributionChannel } from '@/models/distributionChannels';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';

const columnHelper = createColumnHelper<DistributionChannel & { campaignAudienceId: CampaignResponse['audienceId'] }>();

export const getConnectedDestinationsTableColumns = (t: TFunction) =>
  [
    columnHelper.accessor('audience', {
      id: 'audience',
      header: () => t('audiences:table.audience_name'),
      cell: ({ row }) => <p>{row.original.audience.name}</p>,
      minSize: 200,
      maxSize: 200,
      meta: {
        className: () => 'text-xs font-medium text-primary-900',
      },
    }),
    columnHelper.accessor('destination', {
      id: 'destination',
      header: () => t('audiences:table.destination'),
      cell: ({ row }) => <p>{row.original.name}</p>,
      minSize: 200,
      maxSize: 200,
      meta: {
        className: () => 'text-xs font-medium text-primary-900',
      },
    }),
    columnHelper.accessor('id', {
      id: 'id',
      header: () => t('audiences:table.id'),
      cell: ({ row }) => <p>{row.original.id}</p>,
      minSize: 400,
      maxSize: 400,
      meta: {
        align: 'center',
        className: () => 'text-xs text-tertiary-600',
      },
    }),
    columnHelper.accessor('createdOn', {
      id: 'createdOn',
      header: () => t('audiences:table.change'),
      cell: ({ getValue }) => <TimeAgo time={getValue()} />,
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
    // columnHelper.display({
    //   id: 'size',
    //   header: () => t('audiences:table.total_users'),
    //   cell: ({ row }) => <ConnectedDestinationTotalUsersColumn audienceId={row.original.campaignAudienceId} />,
    //   minSize: 150,
    //   maxSize: 150,
    //   meta: {
    //     className: () => 'font-semibold text-tertiary-600',
    //     align: 'center',
    //     nestedClassName: () => 'w-full flex',
    //   },
    // }),
  ] as ColumnDef<DistributionChannel & { campaignAudienceId: CampaignResponse['audienceId'] }>[];
